import { ExpertisePoint, ExpertisePointGroupType } from './expertise-point.types';
import { ProductVariantDto } from './order.types';

export const enum ProductTypeQueryCacheKey {
  GetTramerQuery = 'GetTramerQuery',
  GetKilometerQuery = 'GetKilometerQuery',
}

export const enum UtilQueryCacheKey {
  GetAnnouncements = 'GetAnnouncements',
  GetUnreadAnnouncemenets = 'GetUnreadAnnouncemenets',
  GetUnreadAnnouncementsCount = 'GetUnreadAnnouncementsCount',
  GetProducts = 'GetProducts',
}

export enum ProductType {
  TramerQuery = 10,
  KilometerQuery = 20,
  RoadAssistance = 30,
  UsedCarProtection = 40,
  ECommercePaper = 500,
  ECommerceFile = 501,
  ECommerceTshirt = 502,
  ECommerceSweater = 503,
  ECommercePolar = 504,
  ECommerceGasketLeak = 505,
  AutoPerfume = 506,
}

export enum ApplicationToggleType {
  KmQuery = 10,
  DamageQuery = 20,
}

export interface Announcement {
  id: number;
  title: string;
  description: string;
  isRead?: boolean;
  createdAt: Date;
  isAllSend?: boolean;
  expertisePoints?: ExpertisePoint[];
}

export interface EStoreProduct {
  id: number;
  name: string;
  price: number;
  photoUrl?: string;
  photoUrls?: string[];
  variants?: ProductVariantDto[];
  productType: ProductType;
  description?: string;
  title?: string;
  isActive: boolean;
  groupType?: ExpertisePointGroupType;
  createdAt: Date;
}

export interface AnnouncementResponse extends Omit<Announcement, 'createdAt'> {
  createdAt: string;
}

export interface SendAnnouncementRequest {
  title: string;
  description: string;
  groupType?: ExpertisePointGroupType;
  toExpertisePointIds?: number[];
}

export const ApplicationToggleTypeLabel = new Map<number, string>([
  [ApplicationToggleType.KmQuery, 'Kilometre Sorgulama'],
  [ApplicationToggleType.DamageQuery, 'Hasar Sorgulama'],
]);
